import StatusBadge from 'components/atoms/status-badge'
import { FastSellProductConditionBadge, FastSellProductStatusBadge } from 'domains/fast-sell-product/components'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import PriceUtil from 'utils/price-util'

const propTypes = {
  fastSellProduct : PropTypes.object,
  to              : PropTypes.func
}

const FastSellProductTableRow = ({
  fastSellProduct,
  to
}) => {

  const {
    id,
    name,
    seller,
    serial_code,
    condition,
    year_purchased,
    price_offers,
    product_category,
    product_brand,
    status,
    received_status
  } = fastSellProduct

  const buttonClassName = 'align-self-center my-1 mx-auto'

  return (
    <tr>
      <td>{ id }</td>
      <td>{ name }</td>


      <td>{ product_brand?.label }</td>
      <td>{ product_category?.label }</td>
      <td><FastSellProductConditionBadge condition={ condition } /></td>
      <td>{ serial_code }</td>
      <td>{ year_purchased }</td>
      <td>{ PriceUtil.format(price_offers[0]?.price) }</td>
      <td><FastSellProductStatusBadge status={ status } /></td>
      <td>
        {
          <StatusBadge
            color={
              received_status == 'received'
                ? 'primary'
                : 'warning'
            }
            label={ received_status }
          />
        }
      </td>
      <td>{ seller?.name }</td>
      <td>
        <NavLink
          className={ `btn btn-primary ${buttonClassName}` }
          to={ to(id) }
        >
          { 'Detail' }
        </NavLink>
      </td>
    </tr>
  )
}

FastSellProductTableRow.propTypes = propTypes
export default FastSellProductTableRow